// extracted by mini-css-extract-plugin
export default {"title":"DeleteKpi_title__cn9JY","buttonPart":"DeleteKpi_buttonPart__mt7QE","buttonCancel":"DeleteKpi_buttonCancel__BpBtf","buttonDelete":"DeleteKpi_buttonDelete__2ihSu"};